/* 
    Function from redux library , reducer as argument , state comes from reducers
    transform reducer into store object that will be single source of state in our app 
*/

import thunk from 'redux-thunk';
import logger from 'redux-logger';
import history from '../utils/history';

import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import rootReducer, { ReduxState } from '../reducers/index';
import { composeWithDevTools } from 'redux-devtools-extension';

const middlewares = [];

middlewares.push(thunk);

// if (process.env.NODE_ENV === `development`) { // TODO: FIX THIS IN WP
// middlewares.push(logger); // TODO: Keep this in development only, wok on webpack for this to be accessable
// }

const store = createStore(
    rootReducer(history),
    composeWithDevTools(
        applyMiddleware(routerMiddleware(history), ...middlewares)
    )
);

export default store;
